import React, { FC } from 'react'
import styled from 'styled-components'

import { ShipmentNotificationBar } from '@Components/ShipmentNotificationBar'
import { useTranslation } from '@Globals/Translations'

const EasterBarWrapper = styled(ShipmentNotificationBar)`
  background-color: #FFE787 !important;
`

export const EasterBar: FC = () => {
  const { t } = useTranslation()

  const now = new Date()
  const startDate = new Date('April 13, 2022 16:00:00 (CEST)')
  const endDate = new Date('April 18, 2022 16:00:00 (CEST)')
  if (startDate > now || now > endDate) {
    return null
  }

  return (
    <EasterBarWrapper background="grey" color="black">
      {t('header:EASTER_INFO_MESSAGE_2022')}
    </EasterBarWrapper>
  )
}
